export default {
    artifacts: {
        title: 'Artifcts',
        subtitle: 'Artifcts section',

        artifact: 'Artifcts',
        type: 'Types of artifcts',
        document: 'Document types',
        tag: 'Tags',
        occasion: 'Occasions',
        country: 'Countries',
        century: 'Centuries',
        value: 'Values',
        unit: 'Units',
        valuation: 'Valuation',
        violation_reports: 'Violation reports',
        brain_health: 'Brain health study',
    },
    companies: {
        title: 'Companies',
        subtitle: 'Companies section',

        companies: 'Companies',
        request: 'Companies requests',
        forProfessionals: 'For Professionals page',
    },
    marketing: {
        title: 'Marketing',
        subtitle: 'Marketing section',

        promo_code: 'Promo Codes',
        partner_promo_code: 'Partner Promo Codes',
        qr_code: 'QR Codes',
    },
    subscriptions: {
        title: 'Membership',
        subtitle: 'Membership section',

        plan: 'Membership',
        plan_description: 'Membership cards',
        plan_permission: 'Comparison Table',
        subscription: 'User membership',
        subscription_gift: 'Gift Membership',
        transaction: 'Payments',

        concierge_service: 'Concierge service',

        artiProMembership: 'ARTIPro Membership',
    },
    blog: {
        title: 'Blog',
        subtitle: 'Blog section',

        category: 'Categories',
        post: 'Posts',
    },
    users: {
        title: 'Members',
        subtitle: 'Members section',

        user: 'Members',

        sharing_list: 'Sharing lists',
        circle_list: 'Circle lists',

        email_subscriptions_list: 'Email subscriptions',
        how_know: 'How did you hear?',
    },
    administrators: {
        title: 'Administrators',
        subtitle: 'Administrators section',

        administrator: 'Administrators',
        permissions: 'Permissions',
        roles: 'Roles',
    },
    content: {
        title: 'Content',
        subtitle: 'Content section',

        content: 'Content',
    },
    homepage: {
        title: 'Homepage',
        subtitle: 'Homepage section',

        homepage: 'Homepage',
    },
    pages: {
        title: 'Pages',
        subtitle: 'Pages section',
    },
    faq: {
        title: 'FAQ',
    },
    forMom: {
        title: 'For Mom',
    },
    artiPro: {
        title: 'Arti Pro',
    },
    komen: {
        title: 'Komen page',
    },
}
